import i18n from './index';

const LOCALE = { pt: 'pt-BR', en: 'en-US', es: 'es-ES' };

export const localeOf = () => LOCALE[i18n.language] || 'pt-BR';

export const fmtDate = (ms, opts) =>
  (ms ? new Date(ms).toLocaleDateString(localeOf(), opts) : '—');

export const fmtTime = (ms) =>
  (ms ? new Date(ms).toLocaleTimeString(localeOf(), { hour: '2-digit', minute: '2-digit' }) : '');

export const fmtInt = (v) => (v || 0).toLocaleString(localeOf());

export const fmtUSD = (v) =>
  (v || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 4 });
